import {fromJS, List} from 'immutable'

import {
  SET_PAYOUTS,
  ORDER_PAYOUTS,
  SET_CURRENT_USER_PAYOUTS
} from '../action_types'

const injectKeys = (payout, key) => {
  return payout.merge({key})
}

const sortPayouts = (attr, payout) => payout.get(attr)

const sortPayoutsByTime = (payout) => {
  const time = payout.get('time')
  // TODO: make it -1 * time after adding time to payouts.
  if (time) return time

  return payout.get('key')
}

export default (state = List(), action) => {
  switch (action.type) {
    case SET_PAYOUTS:
    case SET_CURRENT_USER_PAYOUTS:
      return fromJS(action.payouts)
        .map(injectKeys)
        .toList()
        .sortBy(sortPayoutsByTime)
        // TODO: disable this after adding time to payouts
        .reverse()

    case ORDER_PAYOUTS:
      if (action.order === 'desc') {
        return state
          .sortBy(sortPayouts.bind(null, action.attr))
          .reverse()
      }
      else {
        return state
          .sortBy(sortPayouts.bind(null, action.attr))
      }

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/payouts.js
 **/